import { render, staticRenderFns } from "./ConsentsInput.vue?vue&type=template&id=c70ccf5e&"
import script from "./ConsentsInput.vue?vue&type=script&lang=js&"
export * from "./ConsentsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports